import { Accordion } from '../../../../../../components/general/accordion';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { Grid } from '@mui/material';
import { PqrClosingProps } from '../props';
import { usePqrCompensation } from './hook';
import { Checkbox } from '../../../../../../components/general/fields/checkbox';

export const PqrCompensation = ({ closing }: PqrClosingProps) => {
    const { formik } = usePqrCompensation(closing);

    return (
        <Accordion
            title="RESARCIMIENTO"
            icon={<CardGiftcardIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12}>
                    <Checkbox
                        label="Resarcimiento"
                        checked={Boolean(formik.values.compensation)}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
